"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockHadespinLeaderboardEntry = void 0;
const constants_1 = require("../../../constants");
const getMockHadespinLeaderboardEntry = () => __awaiter(void 0, void 0, void 0, function* () {
    const hadespinLeaderboardEntry = {
        user: constants_1.EMPTY_PUBKEY.toBase58(),
        totalSolDeposited: 0,
        totalSolInNftDeposited: 0,
        totalNftDeposited: 0,
        totalFeePayed: 0,
        totalSolWon: 0,
        lastTransactedAt: 0,
        placeholderOne: constants_1.EMPTY_PUBKEY.toBase58(),
        placeholderTwo: constants_1.EMPTY_PUBKEY.toBase58(),
        publicKey: ""
    };
    return hadespinLeaderboardEntry;
});
exports.getMockHadespinLeaderboardEntry = getMockHadespinLeaderboardEntry;
